import React from 'react';
import PropTypes from 'prop-types';
import classes from './core-layout.scss';
import '../../styles/index';

export const CoreLayout = ({ children }) => (
	<div className="container text-center">
		<div className={classes.mainContainer}>
			{children}
		</div>
	</div>
);

CoreLayout.displayName = 'CoreLayout';

CoreLayout.propTypes = {
	children: PropTypes.element.isRequired
};

export default CoreLayout;



// WEBPACK FOOTER //
// ./public/src/layouts/core-layout/index.jsx